export const CarouselData = [
  'JavaScript',
  'Java',
  'SQL',
  'C',
  'Python',
  'HTML',
  'CSS',
  'React',
  'Typescript',
  'Express',
  'Node.js',
  'RESTful APIs',
  'Tailwind',
  'Bootstrap',
  'DB2',
  'Git',
  'AWS',
  'GraphQL',
  'MongoDB',
  'Figma',
  'Agile',
  'UNIX',
  'Linux',
];
